import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { PanelCard } from './ui/PanelCard';
const highlights = ['Web, carta y gestión incluidas', 'Pago único, sin cuotas mensuales', 'Empezamos al confirmar el pago'];
export function PageCTA() {
  return <section className="border-t border-white/10 bg-[#0a0a0a] py-20 sm:py-28" aria-labelledby="page-cta-title" data-id="element-78" data-mp="z4jd9qa1d5zk">
      <div className="container mx-auto px-6 md:px-12" data-id="element-79" data-mp="1qtd40hy2e1ne">
        <motion.div initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.3
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto max-w-4xl" data-id="element-80" data-mp="1qstk4vout36q">
          <PanelCard title="Demos a tu presencia digital una dirección concreta." meta="Empezar" titleId="page-cta-title" data-id="element-81" data-mp="2ajovk2mnhd4a">
            <div className="grid sm:grid-cols-[1.1fr_0.9fr]" data-id="element-82" data-mp="obccxbyh6whc">
              <div className="px-6 py-8 sm:px-9 sm:py-10" data-id="element-83" data-mp="121zedbvmf0h4">
                <p className="text-[15px] leading-relaxed text-neutral-600" data-id="element-84" data-mp="123iv13l6vdjf">
                  Una oferta completa, un precio definido y una ruta de trabajo
                  fácil de seguir.
                </p>
                <ul className="mt-7 space-y-3 border-t border-black/15 pt-6" data-id="element-85" data-mp="1c1gktvip5ie5">
                  {highlights.map(item => <li key={item} className="flex gap-3 text-[13px] leading-relaxed text-neutral-700" data-id="element-86" data-mp="1l0tuopaqg8ze">
                      <CheckIcon size={15} className="mt-0.5 shrink-0 text-black" aria-hidden="true" data-id="element-87" data-mp="1fzea0ycgw4hj" />
                      {item}
                    </li>)}
                </ul>
              </div>
              <div className="flex flex-col justify-between border-t-2 border-black/15 px-6 py-8 sm:border-l-2 sm:border-t-0 sm:px-9 sm:py-10" data-id="element-88" data-mp="1qoipugw13a6v">
                <div data-id="element-89" data-mp="1vmty4n6odcmz">
                  <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-neutral-500" data-id="element-90" data-mp="1vmbuh5honw51">
                    Pago único
                  </p>
                  <p className="mt-4 text-5xl font-medium tracking-[-0.06em] text-black" data-id="element-91" data-mp="24p38nd1y160d">
                    350€
                  </p>
                </div>
                <Link to="/checkout" className="group mt-8 flex items-center justify-center gap-2 bg-black px-5 py-4 text-sm font-semibold text-white transition-colors hover:bg-neutral-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-black focus-visible:ring-offset-2 focus-visible:ring-offset-white" data-id="element-92" data-mp="29l1qehsrnprt">
                  Solicitar mi proyecto
                  <ArrowRightIcon size={16} className="transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" data-id="element-93" data-mp="gqiwqccvufyj" />
                </Link>
              </div>
            </div>
          </PanelCard>
        </motion.div>
      </div>
    </section>;
}